import axios from 'axios'
import * as waxjs from "@waxio/waxjs/dist";
import Link from 'anchor-link'
import { useToast } from 'vue-toastification'
const toast = useToast();
import {
    isWebUri
} from 'valid-url';
import moment from 'moment';
import BrowserTransport from 'anchor-link-browser-transport'
var keys = null
var laccount = null
const marketUrl = process.env.VUE_APP_API_MARKET_URL;
if (localStorage.getItem("ual-wax:autologin") != null) {
    let ualWax = JSON.parse(localStorage.getItem("ual-wax:autologin"))
    keys = ualWax ? ualWax.pubKeys : null
}
const waxOptions = {
    rpcEndpoint: process.env.VUE_APP_CHAIN_FULL_URL,
    userAccount: localStorage.getItem("wax_user"),
    pubKeys: keys,
    tryAutoLogin: false
}
var wax = new waxjs.WaxJS(waxOptions);
const genericCall = async(params, callback) => {
    return await axios
        .get(
            `${assetUrl}?owner=${localStorage.getItem(
            "wax_user"
          )}&${params}`
        )
        .then(callback)
}
const chainUrl = () => {
    if (localStorage.getItem("rpc-link-key") != null) {
        let url = localStorage.getItem("rpc-link-key");
        return `https://${url}/v1/chain`;
    } else {
        return process.env.VUE_APP_CHAIN_API
    }
}
const getAssetUrl = (asset = false) => {
    let link = process.env.VUE_APP_API_URL;
    if (localStorage.getItem("rpc-asset-key") != null) {
        link = localStorage.getItem("rpc-asset-key");
    }
    if (asset) {
        link = `${link}/atomicassets/v1/assets`;
    }
    return link;
}
const assetUrl = getAssetUrl(true);
const getAssetById = async(id, callback) => {
    return await axios
        .get(
            `${process.env.VUE_APP_API_ASSET_URL}/${id}`
        )
        .then(callback)
}
const buy = async(dataParams, onSuccessCallback, onErrorCallback) => {
    laccount = localStorage.getItem("wax_user");
    try {
        const actionData = {
            account: "doublooncoin",
            name: 'transfer',
            authorization: [{
                actor: laccount,
                permission: 'active',
            }],
            data: dataParams,
        }
        if (localStorage.getItem("ual-session-authenticator") != "Wax") {
            return await doSign(actionData, onSuccessCallback, onErrorCallback)
        } else {
            return await signWithWax({ actions: [actionData] }, onSuccessCallback, onErrorCallback)
        }
    } catch (err) {
        return onErrorCallback(err)
    }
}
const saleApi = async(params, callback) => {
    return await axios
        .get(
            `${marketUrl}?owner=${localStorage.getItem(
            "wax_user"
          )}&${params}`
        )
        .then(callback)
}
const genericCallSales = async(id, callback) => {
    return await axios
        .get(
            `https://wax.api.atomicassets.io/atomicmarket/v1/assets/${id}`
        )
        .then(callback)
}
const calculatePrice = (price) => {
    return `${Number(price.average/100000000).toFixed(2)} ${price.token.token_symbol}`;
}
if (localStorage.getItem("wax_user") != null) {
    laccount = localStorage.getItem("wax_user")
}

const getImgUrl = (hash, isVideo) => {
    if (isWebUri(hash)) {
        return hash;
    }
    let url = 'http://ipfs.io/ipfs/' + hash;
    if (isVideo) {
        return url
    }
    // return 'https://images.hive.blog/300x0/' + url;
    return '//images.weserv.nl/?url=' + url + "&w=300&h=300";
}
const callApi = async(params, callback) => {
    return await axios
        .get(`${process.env.VUE_APP_API_ASSET_URL}?owner=${localStorage.getItem('wax_user')}&page=1&limit=100&${params}`)
        .then(callback)
}
const link = new Link({
    transport: new BrowserTransport({
        requestStatus: false
    }),
    chains: [{
        chainId: process.env.VUE_APP_CHAIN_ID,
        nodeUrl: process.env.VUE_APP_CHAIN_FULL_URL,
    }],
})
const setShip = async(car_asset_id, onSuccess) => {
    let authenticator = localStorage.getItem("ual-session-authenticator");
    let userAccount = localStorage.getItem("wax_user")
    if (authenticator != "Wax") {
        return await doSign({
            account: process.env.VUE_APP_CONTRACT,
            name: 'setship',
            authorization: [{
                actor: userAccount,
                permission: 'active',
            }],
            data: {
                account: userAccount,
                car: car_asset_id,
            },
        }, (onSuccess), ((error) => {
            toast.error(errorFormat(error));
            return false;
        }));
    } else {
        try {
            await signWithWax({
                actions: [{
                    account: process.env.VUE_APP_CONTRACT,
                    name: 'setship',
                    authorization: [{
                        actor: userAccount,
                        permission: 'active',
                    }],
                    data: {
                        account: userAccount,
                        car: car_asset_id,
                    },
                }]
            }, (onSuccess), ((error) => {
                toast.error(errorFormat(error));
                return false;
            }));
        } catch (error) {
            toast.error(errorFormat(error));
            return error;
        }
    }
}
const resetShip = async(car_asset_id, onSuccess) => {
    let authenticator = localStorage.getItem("ual-session-authenticator");
    let userAccount = localStorage.getItem("wax_user")
    if (authenticator != "Wax") {
        await doSign({
            account: process.env.VUE_APP_CONTRACT,
            name: 'rmcar',
            authorization: [{
                actor: userAccount,
                permission: 'active',
            }],
            data: {
                account: userAccount,
                id: car_asset_id,
            },
        }, (onSuccess), ((error) => {
            toast.error(errorFormat(error));
            return error;
        }));
    } else {
        try {
            await signWithWax({
                actions: [{
                    account: process.env.VUE_APP_CONTRACT,
                    name: 'rmcar',
                    authorization: [{
                        actor: userAccount,
                        permission: 'active',
                    }],
                    data: {
                        account: userAccount,
                        id: car_asset_id,
                    },
                }]
            }, (onSuccess), ((error) => {
                toast.error(errorFormat(error));
                return error;
            }));
        } catch (error) {
            toast.error(errorFormat(error));
            return error;
        }
    }
}
const getTable = async(table, lowerBound = null, callBack, onError) => {
    return await wax.rpc.get_table_rows({
        scope: process.env.VUE_APP_CONTRACT,
        code: process.env.VUE_APP_CONTRACT,
        index_position: 1,
        json: true,
        limit: 100,
        table: table,
        lower_bound: lowerBound
    }).then((res) => callBack(res)).catch(onError)
}
const getTableAll = async(table, callBack, onError) => {
    return await wax.rpc.get_table_rows({
        scope: process.env.VUE_APP_CONTRACT,
        code: process.env.VUE_APP_CONTRACT,
        index_position: 1,
        json: true,
        limit: -1,
        table: table,
        lower_bound: null
    }).then((res) => callBack(res)).catch(onError)
}
const getTableScope = async(table, lowerBound = null, callBack, onError) => {
    return await wax.rpc.get_table_rows({
        scope: localStorage.getItem("wax_user"),
        code: process.env.VUE_APP_CONTRACT,
        index_position: 1,
        json: true,
        limit: 100,
        table: table,
        lower_bound: lowerBound
    }).then((res) => callBack(res)).catch(onError)
}
const getStakes = async(callBack) => {
    return await getTableScope(
        "staking",
        null,
        (res) => {
            res.rows.forEach(async(elm, i) => {
                await getByTempleteId(elm.reward, (reward) => {
                    res.rows[i].template = reward.data.data.immutable_data;
                });
            });
            return res.rows
        }
    ).then(callBack);
}
const getTableSingle = async(table, lowerBound = null, callBack, onError) => {
    return await wax.rpc.get_table_rows({
        scope: process.env.VUE_APP_CONTRACT,
        code: process.env.VUE_APP_CONTRACT,
        index_position: 1,
        json: true,
        limit: 1,
        table: table,
        lower_bound: lowerBound
    }).then((res) => callBack(res)).catch(onError)
}
const getItemUsage = async(assetid = null, callBack, onError) => {
    return await wax.rpc.get_table_rows({
        scope: process.env.VUE_APP_CONTRACT,
        code: process.env.VUE_APP_CONTRACT,
        index_position: 1,
        json: true,
        limit: 1,
        table: "itemusage",
        lower_bound: assetid,
        upper_bound: assetid,
    }).then(async(res) => {
        if (res.rows.length > 0) {
            return res.rows;
        }
        return null;
    }).then((res) => callBack(res)).catch(onError)
}
const getAttack = async(onSuccess) => {
    const activeUser = localStorage.getItem("wax_user");
    return await wax.rpc.get_table_rows({
        scope: activeUser,
        code: process.env.VUE_APP_CONTRACT,
        index_position: 1,
        json: true,
        limit: 1,
        table: "discover",
        lower_bound: null
    }).then((res) => {
        if (res.rows.length) {
            let final = {
                reward: res.rows[0].reward,
                attack_time: res.rows[0].attack_time,
                end_time: res.rows[0].end_time,
                expiredDate: moment.utc(res.rows[0].end_time).format('YYYY-MM-DDTHH:mm:ss.SSSS'),
                currentUtc: moment.utc(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSSS'),
                gameOver: true,
                duration: res.rows[0].duration,
                captain: res.rows[0].captain,
                ship: res.rows[0].ship,
                supply: res.rows[0].supply,
                food: res.rows[0].food,
                location: res.rows[0].location,
                hoursLeft: 0
            }
            final.gameOver = moment(final.currentUtc).isAfter(moment(final.expiredDate))
            final.hoursLeft = moment.duration(moment(final.expiredDate).diff(moment(final.currentUtc))).asHours()
            return final;
        }
        return false;
    }).then(onSuccess);
}
const getAccount = async(callBack) => {
    laccount = localStorage.getItem("wax_user");
    return await axios
        .post(`${chainUrl()}/get_account`, {
            account_name: laccount ? laccount : localStorage.getItem("wax_user"),
        }).then(callBack)
}
const historyApi = async(action, data, callBack) => {
    laccount = localStorage.getItem("wax_user");
    return await axios
        .post(`${process.env.VUE_APP_HISTORY_API}/${action}`, data).then(callBack)
}
const getBalance = async(callBack) => {
    return await axios
        .post(`${chainUrl()}/get_currency_balance`, {
            account: localStorage.getItem("wax_user"),
            code: "doublooncoin",
            symbol: "DOUB",
        }).then(callBack)
}
const doSign = async(action, onSuccessCallback, onErrorCallback) => {
    await link.restoreSession(process.env.VUE_APP_NAME).then((session) => {
        session.transact({
            actions: [action]
        }, {
            blocksBehind: 1,
            expireSeconds: 120,
        }).then(async(res) => {
            verifyTrans(res, onSuccessCallback);
        }).catch(onErrorCallback)
    }).catch(async(error) => {
        console.log(error);
        const identity = await link.login(process.env.VUE_APP_NAME)
        const { session } = identity
        session.transact({
            actions: [action]
        }, {
            blocksBehind: 1,
            expireSeconds: 120,
        }).then(async(res) => {
            verifyTrans(res, onSuccessCallback);
        }).catch(onErrorCallback)
        return error;
    })
}
const verifyTrans = async(res, onSuccessCallback) => {
    // let status = true;
    setTimeout(async() => {
        onSuccessCallback(res);
        //     while (status) {
        //         const trans = await historyApi("get_transaction", { traces: false, id: res.processed.id }, (r) => r.data);
        //         console.log(trans);
        //         if (Object.hasOwn(trans, 'id')) {
        //             status = false;
        //             onSuccessCallback(res);
        //         } else if (Object.hasOwn(trans, 'error') && trans.error.name == "tx_not_found") {
        //             status = true;
        //         } else {
        //             status = false;
        //             onSuccessCallback(res);
        //         }
        //     }
    }, 1000);
}
const signWithWax = async(action, onSuccessCallback, onErrorCallback) => {
    laccount = localStorage.getItem("wax_user");
    let isAutoLoginAvailable = await wax.isAutoLoginAvailable();
    if (!isAutoLoginAvailable) {
        await wax.login();
    }
    try {
        await wax.api.transact(action, {
            blocksBehind: 3,
            expireSeconds: 120,
            broadcast: true,
            sign: true,
        }).then(async(res) => {
            verifyTrans(res, onSuccessCallback);
        }).catch(onErrorCallback)
    } catch (error) {
        return onErrorCallback(error)
    }
}
const isLogin = () => {
    // check local store and also expiry of session
    if (localStorage.getItem('wax_user')) {
        var sessionDate = localStorage.getItem("ual-session-expiration");
        var d1 = new Date();
        var d2 = new Date(sessionDate);
        return moment(d2).isAfter(moment(d1))
    } else {
        return false
    }
}
const errorFormat = (error) => {
    console.log(error.message, typeof error);
    if (typeof error == "string") {
        console.log(error);
        return "Something went wrong."
    }
    if (!error.error && error.message) {
        return error.message
    }
    if (error.error.what) {
        if (error.error.details) {
            return error.error.details[0].message
        }
        return error.error.what;
    } else {
        return "Transaction failed,try again."
    }
}
const claim = async(onSuccessCallback, onErrorCallback) => {
    laccount = localStorage.getItem("wax_user");
    try {
        const actionData = {
            account: process.env.VUE_APP_CONTRACT,
            name: 'claimreward',
            authorization: [{
                actor: laccount,
                permission: 'active',
            }],
            data: {
                account: laccount
            },
        }
        if (localStorage.getItem("ual-session-authenticator") != "Wax") {
            await doSign(actionData, onSuccessCallback, onErrorCallback)
        } else {
            await signWithWax({ actions: [actionData] }, onSuccessCallback, onErrorCallback)
        }
    } catch (error) {
        onErrorCallback(error)
    }
}
const makeRequestParams = (searchTerm) => {
    let params = "&page=1&limit=100";
    if (searchTerm) {
        params += "&match=" + searchTerm;
    }
    return params;
}
const market = async(callBack, lowerBound = null) => {
    return await wax.rpc.get_table_rows({
        scope: process.env.VUE_APP_CONTRACT,
        code: process.env.VUE_APP_CONTRACT,
        index_position: 1,
        json: true,
        lower_bound: lowerBound,
        limit: 1000,
        table: process.env.VUE_APP_TBL_MARKET
    }).then(async(res) => {
        const requests = res.rows.map(async(val, index) => {
            let nfts = await getByTempleteId(val.asset_t, (res) => res.data.data)
            res.rows[index].asset = nfts
            return val
        });
        if (res.more === true) {
            await market(callBack, res.next_key);
        }
        return Promise.all(requests).then(() => {
            return res.rows
        });
    }).then((res) => callBack(res))
}
const getByTempleteId = async(tmpId, callback) => {
    return axios
        .get(`${process.env.VUE_APP_API_TEMPLATE_URL}/lostsailorsl/${tmpId}`)
        .then((res) => callback(res))
}
const attack = async(dataParams, onSuccessCallback, onErrorCallback) => {
    laccount = localStorage.getItem("wax_user");
    try {
        const actionData = {
            account: "atomicassets",
            name: 'transfer',
            authorization: [{
                actor: laccount,
                permission: 'active',
            }],
            data: dataParams,
        }
        if (localStorage.getItem("ual-session-authenticator") != "Wax") {
            return await doSign(actionData, onSuccessCallback, onErrorCallback)
        } else {
            return await signWithWax({ actions: [actionData] }, onSuccessCallback, onErrorCallback)
        }
    } catch (err) {
        return onErrorCallback(err)
    }
}
const transaction = async(dataParams, onSuccessCallback) => {
    laccount = localStorage.getItem("wax_user");
    try {
        const actionData = {
            account: dataParams.contract,
            name: dataParams.action,
            authorization: [{
                actor: laccount,
                permission: 'active',
            }],
            data: dataParams.data,
        }
        if (localStorage.getItem("ual-session-authenticator") != "Wax") {
            return await doSign(actionData, onSuccessCallback, (error) => {
                error = errorFormat(error);
                toast.error(error);
            })
        } else {
            return await signWithWax({ actions: [actionData] }, onSuccessCallback, (error) => {
                error = errorFormat(error);
                toast.error(error);
            })
        }
    } catch (err) {
        let error = errorFormat(err);
        toast.error(error);
    }
}
const resetAttack = async(onSuccessCallback, onErrorCallback) => {
    laccount = localStorage.getItem("wax_user");
    try {
        const actionData = {
            account: "lostsailorsl",
            name: 'resetattack',
            authorization: [{
                actor: laccount,
                permission: 'active',
            }],
            data: { account: laccount },
        }
        if (localStorage.getItem("ual-session-authenticator") != "Wax") {
            return await doSign(actionData, onSuccessCallback, onErrorCallback)
        } else {
            return await signWithWax({ actions: [actionData] }, onSuccessCallback, onErrorCallback)
        }
    } catch (err) {
        return onErrorCallback(err)
    }
}
const niceFloat = (numberVal) => {
    numberVal = numberVal.replace(/YGD/g, "")
    return parseFloat(numberVal.toString());
}
const removeCurrencySymbol = async(numberVal) => {
    return numberVal.replace(/YGD/g, "");
}
export default {
    niceFloat,
    errorFormat,
    removeCurrencySymbol,
    claim,
    doSign,
    isLogin,
    getStakes,
    getItemUsage,
    genericCall,
    getAssetById,
    resetShip,
    getAccount,
    calculatePrice,
    getByTempleteId,
    callApi,
    buy,
    market,
    getTable,
    getTableSingle,
    getTableScope,
    transaction,
    getAttack,
    attack,
    setShip,
    signWithWax,
    makeRequestParams,
    genericCallSales,
    saleApi,
    historyApi,
    getBalance,
    resetAttack,
    getTableAll,
    verifyTrans,
    getAssetUrl,
    getImgUrl
}